<mf-page title="Nuevo incidente">
  <mf-issue
    (close)="close()"
    (save)="save($event)" />
</mf-page>
